import React from 'react';
import { NavLink } from 'react-router-dom';

import {
  SearchOutlined,
  ShoppingCartOutlined,
  UserOutlined,
  PercentageOutlined
} from '@ant-design/icons';

interface RightMenuListProps {
  deviceType: String;
}

const RightMenuList: React.FC<RightMenuListProps> = (Props) => {
  return (
    <div className="right-menu-mobile">
      <div>
        <div className="mobile-menu-list-item">
          <SearchOutlined />
          <NavLink to="/search" className="white-color-link">
            <span>Search</span>
          </NavLink>
        </div>
        <div className="mobile-menu-list-item">
          <PercentageOutlined />
          <NavLink to="/offers" className="white-color-link">
            <span>Offers</span>
          </NavLink>
        </div>
        <div className="mobile-menu-list-item">
          <UserOutlined />
          <NavLink to="/account" className="white-color-link">
            <span>Account</span>
          </NavLink>
        </div>
        <div className="mobile-menu-list-item">
          <ShoppingCartOutlined />
          <NavLink to="/cart" className="white-color-link">
            <span>Cart</span>
          </NavLink>
        </div>
      </div>
    </div>
  );
};

export default RightMenuList;
